import apiClient from "@/api/client";
import type { CompanyHoliday, ScheduleData, WorkScheduleEntry } from "../types";

export const scheduleApi = {
  getSchedule: (start?: string, end?: string, includeInactive?: boolean) =>
    apiClient
      .get<{ data: ScheduleData }>("/schedule/", {
        params: {
          ...(start ? { start, end } : {}),
          ...(includeInactive ? { include_inactive: "1" } : {}),
        },
      })
      .then((r) => r.data.data),

  createEntry: (data: { entry_type: string; start_date: string; end_date: string; note?: string }) =>
    apiClient
      .post<{ data: WorkScheduleEntry }>("/schedule/entries/", data)
      .then((r) => r.data.data),

  deleteEntry: (id: string) => apiClient.delete(`/schedule/entries/${id}/`),

  approveEntry: (id: string, comment?: string) =>
    apiClient
      .post<{ data: WorkScheduleEntry }>(`/schedule/entries/${id}/approve/`, { comment: comment ?? "" })
      .then((r) => r.data.data),

  rejectEntry: (id: string, comment: string) =>
    apiClient
      .post<{ data: WorkScheduleEntry }>(`/schedule/entries/${id}/reject/`, { comment })
      .then((r) => r.data.data),

  listEntries: (params?: Record<string, string>) =>
    apiClient
      .get<{ data: WorkScheduleEntry[] }>("/schedule/entries/", { params })
      .then((r) => r.data.data),

  setEntryHours: (id: string, payload: { start_hour?: string | null; hours_ranges?: Array<{ start: string; end: string }> | null }) =>
    apiClient
      .patch<{ data: WorkScheduleEntry }>(`/schedule/entries/${id}/`, payload)
      .then((r) => r.data.data),

  listCompanyHolidays: () =>
    apiClient.get<{ data: CompanyHoliday[] }>("/company-holidays/").then((r) => r.data.data),

  createCompanyHoliday: (data: { start_date: string; end_date: string; description?: string }) =>
    apiClient.post<{ data: CompanyHoliday }>("/company-holidays/", data).then((r) => r.data.data),

  deleteCompanyHoliday: (id: string) => apiClient.delete(`/company-holidays/${id}/`),
};
